import { useMemo } from 'react';
import axios from 'axios';

function clearSession() {
  localStorage.removeItem('auth_token');
  localStorage.removeItem('user_id');
  localStorage.removeItem('user_role');
  localStorage.removeItem('username');
  window.location.reload();
}

export function useHttp() {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8000';

  // useMemo garante referência estável entre renders.
  // Sem isso, useCallback/useEffect com [http] como dep criam loops infinitos
  // porque cada render produz uma nova instância axios (nova referência).
  const instance = useMemo(() => {
    const inst = axios.create({
      baseURL: apiUrl,
      timeout: 30000,
      headers: { 'Content-Type': 'application/json' },
    });

    inst.interceptors.request.use((config) => {
      // Token lido do localStorage em tempo de requisição — sempre atualizado
      const token = localStorage.getItem('auth_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    inst.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          clearSession();
        }
        return Promise.reject(error);
      }
    );

    return inst;
  }, [apiUrl]); // apiUrl é constante em runtime — instância criada uma única vez

  return instance;
}
